export default __webpack_public_path__ + "static/media/vehicle_details.9f169b86.svg";